require('./bootstrap');
require('./sweetalert-dev');
require('./jquery.blockUI');

(function ($) {

    var o = $({});

    $.suscribe = function () {

        o.on.apply(o, arguments);
    };
    $.unsuscribe = function () {

        o.off.apply(o, arguments);
    };
    $.publish = function () {

        o.trigger.apply(o, arguments);
    };

}(jQuery));

(function ($) {
    $.loadAjaxRequest = function (ev) {
        // Stop regular handling of "click" in most non-IE browsers
        ev.preventDefault();
        ev.stopPropagation();
        $.blockUI({ css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        } });
        // Load the new content into the div (same code you had)
        $('#form-area').load($(this).attr('href'), function () {
            $('#form-area').slideDown();
            //loadIds();
        });

        $.unblockUI();
        // Stop regular handling of "click" in IE (and some others)
        return false;
    };


    $.simpleAjaxSubmit = function (ev) {

        ev.preventDefault();
        ev.stopPropagation();
        $.blockUI({ css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        } });
        if($.sendingAjax){
            return false;
        }
        $.sendingAjax = true;
        var form = $(this);
        var method = form.find('input[name="_method"]').val() || 'POST';
        $.ajax({
            type: method,
            url: form.prop('action'),
            data: form.serialize(),
            complete: function() {
                $.sendingAjax = false;
            },
            success: function (data) {
                $.unblockUI();

                if (typeof $.simpleSubmitSuccess === "function") {
                    $.simpleSubmitSuccess(data);
                }
            },
            error: function (jqXhr, json, errorThrown) {
                $.unblockUI();
                var errors = jqXhr.responseJSON['errors'];
                var errorsHtml = "<ul>";
                $.each(errors, function (key, value) {
                    errorsHtml += '<li>' + value[0] + '</li>';
                });
                errorsHtml += '</ul>';

                swal({
                    title: 'Error!',
                    text: errorsHtml,
                    type: "error",
                    html: true
                });


            }
        });

    };
    $.submitAjaxRequest = function (ev) {

        ev.preventDefault();
        ev.stopPropagation();
        $.blockUI({ css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        } });
        if($.sendingAjax){
            return false;
        }
        $.sendingAjax = true;
        var form = $(this);
        var method = form.find('input[name="_method"]').val() || 'POST';
        $.ajax({
            type: method,
            url: form.prop('action'),
            data: form.serialize(),
            complete: function() {
                $.sendingAjax = false;
            },
            success: function () {
                $.unblockUI();
                var message = form.data('remote-success-message');

                if (message) {

                    swal(message, '', "success");
                }
                if (typeof laDataTable === 'undefined') {

                } else {

                    laDataTable.ajax.reload(null, false);

                }
                if (typeof laTrashTable === 'undefined') {

                } else {
                    setTimeout(function () {
                        laTrashTable.ajax.reload(null, false);
                    }, 500);

                }
                $('#form-area').html('').slideUp();

            },
            error: function (jqXhr, json, errorThrown) {
                $.unblockUI();
                var errors = jqXhr.responseJSON['errors'];
                var errorsHtml = "<ul>";
                $.each(errors, function (key, value) {
                    errorsHtml += '<li>' + value[0] + '</li>';
                });
                errorsHtml += '</ul>';

                swal({
                    title: 'Error!',
                    text: errorsHtml,
                    type: "error",
                    html: true
                });


            }
        });

    };

    $.confirmAjaxRequest = function (ev) {

        ev.preventDefault();
        ev.stopPropagation();

        if($.sendingAjax){
            return false;
        }
        $.sendingAjax = true;
        var form = $(this);
        var prompt = form.data('table-confirm');
        var promptmessage = form.data('table-message');
        var method = form.find('input[name="_method"]').val() || 'POST';
        swal({
            title: prompt,
            text: promptmessage,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Ok!"
        }, function (isConfirm) {
            if (isConfirm) {


                $.ajax({
                    type: method,
                    url: form.prop('action'),
                    data: form.serialize(),
                    complete: function() {
                        $.sendingAjax = false;
                    },
                    success: function (data) {
                        var message = form.data('remote-success-message');

                        if (message) {
                            swal(message, '', "success");
                        }
                        if (typeof laDataTable === 'undefined') {

                        } else {
                            laDataTable.ajax.reload(null, false);
                        }
                        if (typeof laTrashTable === 'undefined') {

                        } else {
                            setTimeout(function () {
                                laTrashTable.ajax.reload(null, false);
                            }, 500);
                        }


                        if (typeof $.confirmAjaxSuccess === "function") {
                            $.confirmAjaxSuccess(data);
                        }


                        $('#form-area').html('').slideUp();
                    },
                    error: function (jqXhr, json, errorThrown) {
                        var errors = jqXhr.responseJSON['errors'];
                        var errorsHtml = "<ul>";
                        $.each(errors, function (key, value) {
                            errorsHtml += '<li>' + value[0] + '</li>';
                        });
                        errorsHtml += '</ul>';
                        swal({
                            title: 'Error!',
                            text: errorsHtml,
                            type: "error",
                            html: true
                        });

                    }
                });

            }
        });
    };

    $.confirmAjaxJson = function (ev) {

        ev.preventDefault();
        ev.stopPropagation();
        $.blockUI({ css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        } });
        if($.sendingAjax){
            return false;
        }
        $.sendingAjax = true;
        var form = $(this);
        var method = form.find('input[name="_method"]').val() || 'POST';
        var printURL = form.data('purl');
        var successUrl = form.data('surl');
        var successprompt = form.data('prompt');
        var yesbutton = form.data('yesbutton');
        var nobutton = form.data('nobutton');
        var data = form.serializeArray();
        data.push({name: "contenidos", value: JSON.stringify($.toSendJsonArrayVar)});
        $.ajax({
            type: method,
            url: form.prop('action'),
            data: data,
            complete: function() {
                $.sendingAjax = false;
            },
            success: function (data) {
                $.unblockUI();
                var message = form.data('remote-success-message');
                destinationId = data;
                if (message) {

                    swal({
                        title: successprompt,
                        text: message,
                        type: "success",
                        showCancelButton: true,
                        confirmButtonText: yesbutton,
                        cancelButtonText: nobutton,
                        closeOnConfirm: false,
                        closeOnCancel: false
                        // type: "warning",
                        //    confirmButtonColor: "#DD6B55",
                    }, function (isConfirm) {
                        if (isConfirm) {
                            location.href = printURL + destinationId;
                        } else {
                            if (successUrl !== 'return') {
                                location.href = successUrl;
                            } else {
                                swal.close();
                            }
                        }
                    });

                }

            },
            error: function (jqXhr, json, errorThrown) {
                $.unblockUI();
                var errors = jqXhr.responseJSON['errors'];
                var errorsHtml = "<ul>";
                $.each(errors, function (key, value) {
                    errorsHtml += '<li>' + value[0] + '</li>';
                });
                errorsHtml += '</ul>';
                swal({
                    title: 'Error!',
                    text: errorsHtml,
                    type: "error",
                    html: true
                });

            }
        });


    };
    $.sendingAjax = false;
    $.bindjaxRequest = function (e) {

        // Forms maked with "data-remote" attribute will submit via AJAX
        $('form[data-remote]').off('submit').on('submit', $.submitAjaxRequest);

        // Forms maked with "data-confirm" attribute will ask for confirmation
        $('input[data-confirm], button[data-confirm], a[data-confirm]').off('click').on('click', $.confirmAjaxRequest);

        // Forms maked with "data-json-confirm" attribute will ask for confirmation and send JSON
        $('input[data-json-confirm], button[data-json-confirm], a[data-json-confirm]').off('click').on('click', $.confirmAjaxJson);
        $('form[data-json-confirm]').off('submit').on('submit', $.confirmAjaxJson);
        $.toSendJsonArrayVar = {};
        // Forms maked with "data-remote" attribute will submit via AJAX
        $('button[data-flash-dismiss]').off('click').on('click', function () {
            $.publish('flash.submitted');
        });

        // Forms maked with "data-remote" attribute will submit via AJAX
        $('#content-table tbody').off('submit', 'form[data-table-confirm]').on('submit', 'form[data-table-confirm]', $.confirmAjaxRequest);
        // Edit buttons will load edit form
        $('#content-table tbody').off('click', 'a.btn_ajax').on('click', 'a.btn_ajax', $.loadAjaxRequest);

        // Forms maked with "data-remote" attribute will submit via AJAX
        $('#trashed-table tbody').off('submit', 'form[data-table-confirm]').on('submit', 'form[data-table-confirm]', $.confirmAjaxRequest);
        // Edit buttons will load edit form
        //$('#trashed-table tbody').off('click', 'a').on('click', 'a', $.loadAjaxRequest);
        // Links for creating new forms attached to ajax
        $('#create-new-link').off('click').on('click', $.loadAjaxRequest);
    };
    $.bindjaxRequest();


    $('#default-view-btn').on('click', function (e) {
        $('#trash-table-area').slideUp();
        $('#content-table-area').slideDown();
    });

    $('#trash-view-btn').on('click', function (e) {
        $('#trash-table-area').slideToggle();
        $('#content-table-area').slideToggle();
        $.viewTrashed(trashroute, columnas, language);
    });
    $.viewContent = function (route, columnas, language, orden) {
        laDataTable = $('#content-table').DataTable({
            processing: true,
            serverSide: true,
            ajax: route,
            order: orden,
            columns: columnas,
            language: {
                url: language
            }
        });
        $.bindjaxRequest();

    };
    $.viewTrashed = function (route, columnas, language, orden) {

        if (!$.fn.DataTable.isDataTable('#trashed-table')) {

            laTrashTable = $('#trashed-table').DataTable({
                processing: true,
                serverSide: true,
                ajax: route,
                order: orden,
                columns: columnas,
                language: {
                    url: language
                }
            });
            $.bindjaxRequest();

        }
    }
    $('body').ajaxStart(function () {
        $(this).css({'cursor': 'wait'});
    }).ajaxStop(function () {
        $(this).css({'cursor': 'default'});
    });
}(jQuery));